/* ✦ Newsletter popup: timed / scroll / exit-intent triggers, frequency cap, success state after sign-up. */
(function () {
  if (customElements.get('bz-popup')) return;
  const KEY = 'bz:popup:seen';
  const DONE = 'bz:popup:subscribed';

  class BzPopup extends HTMLElement {
    connectedCallback() {
      const params = new URLSearchParams(location.search);
      this.forced = params.get('bz_popup') === '1';
      this.success = !!this.querySelector('[data-bz-pop-success]');
      this.querySelectorAll('[data-bz-pop-close]').forEach((b) => b.addEventListener('click', () => this.close()));
      this.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.close(); });
      const copy = this.querySelector('[data-bz-copy]');
      if (copy) copy.addEventListener('click', () => this.copy(copy));
      const form = this.querySelector('form');
      if (form) form.addEventListener('submit', () => { try { localStorage.setItem(DONE, '1'); } catch (e) {} });

      if (this.success) return this.open();
      if (this.forced) return setTimeout(() => this.open(), 400);
      if (!this.shouldShow()) return;
      this.arm();
    }

    shouldShow() {
      if (['cart', 'captcha', 'password'].includes(this.dataset.template)) return false;
      if (window.Shopify && window.Shopify.designMode) return false;
      try {
        if (localStorage.getItem(DONE) === '1') return false;
        const seen = Number(localStorage.getItem(KEY) || 0);
        const days = Number(this.dataset.days) || 7;
        if (seen && Date.now() - seen < days * 864e5) return false;
      } catch (e) {}
      if (this.dataset.hideApp === 'true' && this.appPopupPresent()) return false;
      return true;
    }

    appPopupPresent() {
      return !!document.querySelector('#pop-convert-app, [id^="pop-convert"], .klaviyo-form, .needsclick[class*="kl-private"]');
    }

    arm() {
      const fire = () => {
        if (this.armed === false) return;
        this.armed = false;
        // re-check late-loading app popups
        if (this.dataset.hideApp === 'true' && this.appPopupPresent()) return;
        this.open();
        cleanup();
      };
      const delay = Number(this.dataset.delay) || 0;
      const scrollPct = Number(this.dataset.scroll) || 0;
      let timer;
      const onScroll = () => {
        const max = document.documentElement.scrollHeight - innerHeight;
        if (max > 0 && (scrollY / max) * 100 >= scrollPct) fire();
      };
      const onLeave = (e) => { if (e.clientY <= 0 && !e.relatedTarget) fire(); };
      const cleanup = () => {
        clearTimeout(timer);
        window.removeEventListener('scroll', onScroll);
        document.removeEventListener('mouseout', onLeave);
      };
      if (delay > 0) timer = setTimeout(fire, delay * 1000);
      if (scrollPct > 0) window.addEventListener('scroll', onScroll, { passive: true });
      if (this.dataset.exit === 'true' && window.matchMedia('(pointer: fine)').matches) document.addEventListener('mouseout', onLeave);
    }

    open() {
      this.lastFocus = document.activeElement;
      this.hidden = false;
      document.documentElement.classList.add('bz-pop-open');
      requestAnimationFrame(() => requestAnimationFrame(() => this.classList.add('is-open')));
      try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {}
      setTimeout(() => {
        const first = this.querySelector('input[type="text"], input[type="email"], [data-bz-copy], .bz-btn');
        if (first && window.matchMedia('(pointer: fine)').matches) first.focus({ preventScroll: true });
      }, 450);
    }

    close() {
      this.classList.remove('is-open');
      document.documentElement.classList.remove('bz-pop-open');
      setTimeout(() => { this.hidden = true; }, 450);
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus({ preventScroll: true });
    }

    async copy(btn) {
      const code = btn.dataset.bzCopy;
      try {
        await navigator.clipboard.writeText(code);
      } catch (e) {
        const t = document.createElement('textarea');
        t.value = code;
        document.body.appendChild(t);
        t.select();
        try { document.execCommand('copy'); } catch (err) {}
        t.remove();
      }
      btn.classList.add('is-copied');
      const label = btn.querySelector('[data-bz-copy-label]');
      if (label) label.textContent = '✓';
    }
  }
  customElements.define('bz-popup', BzPopup);
})();
